/** The button only needs to know whether runs exist; the viewer page refetches on open. */
export const RUNS_STALE_TIME_MS = 5 * 60 * 1000
